import _defineProperty from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _createForOfIteratorHelper from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { useCss } from './use-css.js';
import { useMantineTheme, useMantineProviderStyles, useMantineEmotionCache } from '../theme/MantineProvider.js';
import { mergeClassNames } from './utils/merge-class-names/merge-class-names.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
function createRef(refName) {
  return "__mantine-ref-".concat(refName || "");
}
function getStyles(styles, theme, params) {
  var extractStyles = function extractStyles(stylesPartial) {
    return typeof stylesPartial === "function" ? stylesPartial(theme, params || {}) : stylesPartial || {};
  };
  if (Array.isArray(styles)) {
    return styles.map(function (item) {
      return extractStyles(item.styles);
    }).reduce(function (acc, item) {
      Object.keys(item).forEach(function (key) {
        if (!acc[key]) {
          acc[key] = __spreadValues({}, item[key]);
        } else {
          acc[key] = __spreadValues(__spreadValues({}, acc[key]), item[key]);
        }
      });
      return acc;
    }, {});
  }
  return extractStyles(styles);
}
function createStyles(input) {
  var getCssObject = typeof input === "function" ? input : function () {
    return input;
  };
  function useStyles(params, options) {
    var theme = useMantineTheme();
    var context = useMantineProviderStyles(options == null ? void 0 : options.name);
    var cache = useMantineEmotionCache();
    var _useCss = useCss(),
      css = _useCss.css,
      cx = _useCss.cx;
    var cssObject = getCssObject(theme, params, createRef);
    var componentStyles = getStyles(options == null ? void 0 : options.styles, theme, params);
    var providerStyles = getStyles(context, theme, params);
    var classes = Object.fromEntries(Object.keys(cssObject).map(function (key) {
      var mergedStyles = cx(_defineProperty({}, css(cssObject[key]), !(options == null ? void 0 : options.unstyled)), css(providerStyles[key]), css(componentStyles[key]));
      return [key, mergedStyles];
    }));
    return {
      classes: mergeClassNames({
        cx: cx,
        classes: classes,
        context: context,
        classNames: options == null ? void 0 : options.classNames,
        name: options == null ? void 0 : options.name,
        cache: cache
      }),
      cx: cx,
      theme: theme
    };
  }
  return useStyles;
}
export { createStyles };